export default __webpack_public_path__ + "maps-examples-line-gradient-thumbnail-480-0123a1bad554e073152523104316f08f.webp";